export class FormPayload {

  constructor(payload) {

    this._title = typeof payload.title !== 'undefined' ? payload.title : '';
    this._icon = payload.icon
    this._block = typeof payload.block !== 'undefined' ? payload.block : false;
    this._confirm = false;
    this._formStruct = [];
  }

  addField(field) {
    if(field instanceof FormStructField) {
      this._formStruct.push(field);
    }
    else throw new Error("Field must be an instance of FormStructField class");
  }

  setConfirm(confirm) {
    if(confirm instanceof Confirm) {
      this._confirm = confirm;
    }
    else throw new Error("Confirm must be an instance of Confirm class");
  }

  get title() {
    return this._title;
  }

  get icon() {
    return this._icon;
  }

  get block() {
    return this._block;
  }

  get confirm() {
    return this._confirm;
  }

  get formStruct() {
    return this._formStruct;
  }
}

export class Confirm {

  constructor(confirm) {
    this._field1 = typeof confirm.field1 !== 'undefined' ? confirm.field1 : '';
    this._field2 = typeof confirm.field2 !== 'undefined' ? confirm.field2 : '';
  }

  get field1() {
    return this._field1;
  }

  get field2() {
    return this._field2;
  }
}

export class FormStructField {

  constructor(struct) {
    this._name = struct.name
    this._label = struct.label
    this._type = struct.type
    this._icon = struct.icon
    this._show = struct.show
    this.validator = null
    this._select = (struct.select)?struct.select:null
    this._meter = typeof struct.meter !== 'undefined' ? struct.meter : false
    this._default = struct.default
    this._hint = struct.hint
    this._disableIfDefined = struct.disableIfDefined
    this._if = struct.if
    this._randgen = struct.randgen
  }

  addSelect(icon, item) {
    if(this._select === null) this._select = []
    this._select.push({icon: icon, item: item})
  }

  setValidator(validator) {
    if(validator instanceof Validator) {
      this.validator = validator;
    }
    else throw new Error("Validator must be instance of Validator class");
  }

  get select() {
    return this._select;
  }

  get name() {
    return this._name;
  }

  get label() {
    return this._label;
  }

  get type() {
    return this._type;
  }

  get icon() {
    return this._icon;
  }

  get show(){
    return this._show
  }

  get meter() {
    return this._meter;
  }

  get default() {
    return this._default;
  }

  get hint() {
    return this._hint;
  }

  get disableIfDefined(){
    return this._disableIfDefined
  }

  get if(){
    return this._if
  }

  get randgen(){
    return this._randgen
  }
}

export class Validator {

  constructor(validator) {

    this._regex = typeof validator.regex !== 'undefined' ? validator.regex : '';
    this._required = typeof validator.required !== 'undefined' ? validator.required : true;
    this._min = typeof validator.min !== 'undefined' ? validator.min : 2;
    this._max = typeof validator.max !== 'undefined' ? validator.max : 20;
  }

  get regex() {
    return this._regex;
  }

  get required() {
    return this._required;
  }

  get min() {
    return this._min;
  }

  get max() {
    return this._max;
  }
}
